import React, {PureComponent} from "react";
import {Link} from "react-router-dom";

import Card from "../Styled/Dasboard/Card.jsx";
import CardRow from "../Styled/Dasboard/CardRow.jsx";
import CardCol from "../Styled/Dasboard/CardCol.jsx";
import * as EmbarqIcon from "./assets/images/logo-embarq.svg";
import * as NumbrIcon from "./assets/images/logo-numbr.svg";

import './Partnership.scss'

export default class Partnership extends PureComponent{
  render() {
    const {generate} = this.props
    return (
      <div className="dashboard-row">
        <div className="dashboard-col">
          <Card title={'Nos partenaires'} className={'partnership'}>
            <CardRow>
              <CardCol>
                <p className="dashboard-card-col-title">Portage salarial</p>
                <p className="dashboard-card-col-txt">
                  Continuez à profiter des avantages du salariat grâce au portage salarial !{' '}
                  Embarq transforme votre chiffre d’affaires en un bulletin de salaire contre un pourcentage de votre
                  CA.
                </p>
                <div className="dashboard-row partnership-card-footer">
                  <div className="dashboard-col">
                    <img src={EmbarqIcon} alt="Embarq : La vie d’indépendant et le confort du salariat"/>
                  </div>
                  <div className="dashboard-col">
                    <Link className="btn btn-primary" to={generate({name: 'partnerships'})}>Voir plus</Link>
                  </div>
                </div>
              </CardCol>

              <CardCol>
                <p className="dashboard-card-col-title">Expert comptable</p>
                <p className="dashboard-card-col-txt">
                  Déléguez la gestion de votre comptabilité, factures et frais.{' '}
                  Ils peuvent également optimiser fiscalement vos revenus et vous aider à créer votre société si besoin.
                </p>

                <div className="dashboard-row partnership-card-footer">
                  <div className="dashboard-col">
                    <img src={NumbrIcon} alt="Numbr, libres d'entreprendre !"/>
                  </div>
                  <div className="dashboard-col">
                    <Link className="btn btn-primary" to={generate({name: 'partnerships'})}>Voir plus</Link>
                  </div>
                </div>
              </CardCol>
            </CardRow>
          </Card>
        </div>
      </div>
    )
  }
}